import React from "react";
import { Box } from "@mui/material";
import { Icon } from "@iconify/react";
import { LUXURY } from "data/guestLuxuryTheme";

const ICONS = {
  stay: "mdi:flower-outline",
  dine: "mdi:silverware-fork-knife",
  "room-service": "mdi:room-service-outline",
  buffet: "mdi:food",
  breakfast: "mdi:coffee-outline",
  lunch: "mdi:hamburger",
  dinner: "mdi:noodles",
  offers: "mdi:tag-outline",
  housekeeping: "mdi:broom",
  laundry: "mdi:tshirt-crew-outline",
  makeup: "mdi:bed-king-outline",
  maintenance: "mdi:hammer-wrench",
  amenities: "mdi:bottle-tonic-plus-outline",
  concierge: "mdi:account-tie-outline",
  help: "mdi:face-agent",
  requests: "mdi:clipboard-check-outline",
  rate: "mdi:star-outline",
  wifi: "mdi:wifi",
  events: "mdi:calendar-blank-outline",
  checkout: "mdi:bag-suitcase-outline",
};

export const GuestIcon = ({ name = "stay", size = 44, variant = "badge", color }) => {
  const icon = ICONS[name] || ICONS.stay;
  const radius = size >= 72 ? "22px" : size >= 52 ? "16px" : "12px";
  const iconSize = variant === "plain" ? size : Math.round(size * 0.48);
  const mark = variant === "mark";
  const tone = color || LUXURY.gold;

  if (variant === "plain") {
    return (
      <Box
        aria-hidden
        sx={{
          width: size,
          height: size,
          color: tone,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          "& svg": { display: "block" },
        }}
      >
        <Icon icon={icon} width={iconSize} height={iconSize} color="currentColor" />
      </Box>
    );
  }

  return (
    <Box
      aria-hidden
      sx={{
        width: size,
        height: size,
        borderRadius: mark ? "50%" : radius,
        bgcolor: mark ? "rgba(255,255,255,0.92)" : LUXURY.cardSoft,
        color: mark ? LUXURY.forestDeep : tone,
        border: mark ? 0 : `1px solid ${LUXURY.cardBorder}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        boxShadow: mark ? "0 6px 14px rgba(0,0,0,0.25)" : "none",
        "& svg": { display: "block" },
      }}
    >
      <Icon icon={icon} width={iconSize} height={iconSize} color="currentColor" />
    </Box>
  );
};

export default GuestIcon;
